const BusEnum = Object.freeze({

  KEEP_ALIVE: "KEEP_ALIVE",
  HEARTBEAT: "HEARTBEAT",
  BROADCAST: "BROADCAST",
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  WARNING: "WARNING",
  ERROR: "ERROR",
  NOTIFICATION_NEW: "NOTIFICATION_NEW",
  // Diffusé par le backend quand un nouveau frontend est en ligne (AppBuildInfoService).
  FRONTEND_UPDATE: "FRONTEND_UPDATE",
  BROADCAST_BANNER: "BROADCAST_BANNER",
  PROFILE_IMAGE_UPDATE: "PROFIL_UPDATE_LOCAL",
  SHOW_REGISTER_WDW: "SHOW_REGISTER_WDW",
  SHOW_SOCIAL_LOGIN: "SHOW_SOCIAL_LOGIN",
  USER_UPDATE_GEO: "USER_UPDATE_GEO",
  LANGUAGE_UPDATE: "LANGUAGE_UPDATE",
  THEME_UPDATE: "THEME_UPDATE",
  USER_ACCOUNT_UPDATE: "USER_ACCOUNT_UPDATE",
  AUTH_UPDATE: "AUTH_UPDATE",
  PLAYER_PLAY: "PLAYER_PLAY",
  PLAYER_STOP: "PLAYER_STOP",
  PLAYER_BACKWARD: "PLAYER_BACKWARD",
  PLAYER_FORWARD: "PLAYER_FORWARD",
  PLAYER_SYNTH: "PLAYER_SYNTH",

  ACE_USER_UPDATED: "ACE_USER_UPDATED",
  ACE_USER_DETAIL_COMPUTED: "ACE_USER_DETAIL_COMPUTED",

  RMS_TICKET_UPDATED: "RMS_TICKET_UPDATED",
  SPRINT_TICKET_RETRIEVED: "SPRINT_TICKET_RETRIEVED",

  // CDT (Trésorerie) — notifications de progression d'import/export (WebSocket).
  // La valeur DOIT correspondre exactement au `cmd` émis par le backend
  // (ChannelMessageInterface), sinon les progress-dialogs ne reçoivent rien.
  CMD_CDT_NOTIFICATION: "CMD_CDT_NOTIFICATION",
  CMD_CDT_EXCHANGE_NOTIFICATION: "CMD_CDT_EXCHANGE_NOTIFICATION",

  // Chat and messaging
  CONNECTED : 'CONNECTED',
  CHAT: 'CHAT',
  TYPING: 'TYPING',

  // Video calls
  CALL: 'CALL',

  // Screen sharing
  SCREEN_SHARE: 'SCREEN_SHARE',

  // User status
  USER_STATUS_CHANGE: 'USER_STATUS_CHANGE',

  // UI navigation
  OPEN_CHAT: 'OPEN_CHAT',
  OPEN_SHARE_SENDER: 'OPEN_SHARE_SENDER',
  OPEN_SHARE_RECEIVER: 'OPEN_SHARE_RECEIVER',
  OPEN_ROOM: 'OPEN_ROOM',

  // WebRTC connection events
  WEBRTC_CONNECTION_ESTABLISHED: 'WEBRTC_CONNECTION_ESTABLISHED',
  WEBRTC_CONNECTION_FAILED: 'WEBRTC_CONNECTION_FAILED',
  WEBRTC_CONNECTION_CLOSED: 'WEBRTC_CONNECTION_CLOSED',
  WEBRTC_REMOTE_STREAM_ADDED: 'WEBRTC_REMOTE_STREAM_ADDED',
  WEBRTC_OFFER_RECEIVED : 'WEBRTC_OFFER_RECEIVED',

  JITSI_MEETING: 'JITSI_MEETING',

  TALENT_QUIZ_USER_RESULT_UPDATED : 'TALENT_QUIZ_USER_RESULT_UPDATED',

  TEV_PRODUCT_SELECTED : 'TEV_PRODUCT_SELECTED',
  TEV_TEST_UPDATED : 'TEV_TEST_UPDATED',
  TEV_CAMP_TEST_UPDATED : 'TEV_CAMP_TEST_UPDATED',
  TEV_TEST_CALLBACK : 'TEV_TEST_CALLBACK',

  MSG_CTK_NOTIFICATION : "MSG_CTK_NOTIFICATION"
});

export default BusEnum;
